import {
  GET_REVENUE_LIST,
  GET_REVENUE_LIST_SUCCESS,
  GET_REVENUE_LIST_FAILED,
  EXPORT_REVENUE_LIST,
  EXPORT_REVENUE_LIST_SUCCESS,
  EXPORT_REVENUE_LIST_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingRevenueList: true,
  isLoadingExportRevenueList: false,
  revenueList: [],
  totalRevenue: 0,
};

const revenue = (state = initialState, action) => {
  switch (action.type) {
    case GET_REVENUE_LIST:
      return {
        ...state,
        isLoadingRevenueList: true,
      };

    case GET_REVENUE_LIST_SUCCESS:
      return {
        ...state,
        revenueList: action.payload.data,
        totalRevenue: action.payload.total,
        isLoadingRevenueList: false,
      };

    case GET_REVENUE_LIST_FAILED:
      return {
        ...state,
        isLoadingRevenueList: false,
      };

    case EXPORT_REVENUE_LIST:
      return {
        ...state,
        isLoadingExportRevenueList: true,
      };

    case EXPORT_REVENUE_LIST_SUCCESS:
      return {
        ...state,
        isLoadingExportRevenueList: false,
      };

    case EXPORT_REVENUE_LIST_FAILED:
      return {
        ...state,
        isLoadingExportRevenueList: false,
      };

    default:
      return state;
  }
};

export default revenue;
